import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center gap-4" }
const _hoisted_2 = { class: "grid lg:grid-cols-2 gap-12 w-full h-auto place-items-center overflow-hidden" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]

import BaseCard from '@/features/global/BaseCard.vue';
import FFSS1 from '@/assets/Projects/FinalFantasyPhotos/FFSS1.png';
import FFSS3 from '@/assets/Projects/FinalFantasyPhotos/FFSS3.png';
import { useImageViewer } from '@/features/composables/useImageViewer';


export default /*@__PURE__*/_defineComponent({
  __name: 'FinalFantasyProject',
  setup(__props) {

const { openImageMenu } = useImageViewer();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCard, {
    title: 'RPG Battle Simulator',
    highlightLastWord: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "w-full grid lg:grid-cols-2 lg:gap-20" }, [
          _createElementVNode("h5", { class: "lg:justify-self-end lg:pr-6 font-medium" }, "Solo Engineer"),
          _createElementVNode("h5", { class: "lg:justify-self-start lg:pl-6 font-medium" }, "April 2025 - May 2025")
        ], -1)),
        _cache[3] || (_cache[3] = _createElementVNode("p", { class: "text-center items-center px-4 gap-2" }, [
          _createElementVNode("span", { class: "block" }, " Battle simulator akin to Final Fantasy "),
          _createElementVNode("span", { class: "block" }, " X11 forwarding using solely C & gfx graphics library "),
          _createElementVNode("span", { class: "block" }, " Interface with terminal for name input, then entirely inside the game afterwards "),
          _createElementVNode("span", { class: "block" }, " Unique pixel sprites, animated moves, menus, and classes "),
          _createElementVNode("a", {
            href: "https://youtu.be/EPzwJwWxlPI",
            target: "_blank",
            class: "link-in-text"
          }, "Watch a demo!")
        ], -1)),
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("img", {
            class: "w-full h-auto rounded-lg hidden lg:block cursor-pointer",
            src: _unref(FFSS1),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openImageMenu)(_unref(FFSS1), 'Battle Sim Screenshot 1', $event.currentTarget)))
          }, null, 8, _hoisted_3),
          _createElementVNode("img", {
            class: "w-full h-auto rounded-lg cursor-pointer",
            src: _unref(FFSS3),
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_unref(openImageMenu)(_unref(FFSS3), 'Battle Sim Screenshot 2', $event.currentTarget)))
          }, null, 8, _hoisted_4)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})